import cognito from './auth.json' // eslint-disable-line
import cognitoProd from './auth-prod.json' // eslint-disable-line
import stripeConfig from './stripe.json'
import { env } from './env'
import { productContext } from '../utilities/context'

const cognitoToUse = env.stage === 'prod' ? cognitoProd : cognito
const product = productContext.charAt(0).toUpperCase() + productContext.slice(1) // 'Oversight' || 'Leavecal' || 'Tayg' || 'Subsync'
// eslint-disable-next-line
const auth = (cognitoToUse as any)[product]
const url = env.appUrls[product as keyof typeof env.appUrls]

const stripe = stripeConfig[env.stage]

export const awsConfig = {
	Auth: {
		region: auth.Auth.region,
		userPoolId: auth.Auth.userPoolId,
		userPoolWebClientId: auth.Auth.userPoolWebClientId,
		oauth: {
			domain: auth.Auth.domain,
			scope: ['openid', 'profile', 'email', 'aws.cognito.signin.user.admin'],
			redirectSignIn: url,
			redirectSignOut: url,
			responseType: 'code',
		},
	},
}

export const ApiConfig = {
	ControllerBaseUrl: env.apiBaseUrl,
}

export const S3Config = {
	BaseUrl: env.s3BaseUrl,
}

export const StripeConfig = {
	InstallLink: stripe.install_link,
	AppId: stripe.app_id,
}

export const signUpConfig = {
	header: 'Oversight Sign Up',
	hideAllDefaults: true,
	hiddenDefaults: [],
	defaultCountryCode: '1',
	signUpFields: [
		{
			label: 'Email',
			key: 'email',
			required: true,
			displayOrder: 1,
			type: 'string',
			placeholder: 'Email',
		},
		{
			label: 'Password',
			key: 'password',
			required: true,
			displayOrder: 2,
			type: 'password',
			placeholder: 'Password',
		},
		{
			label: 'Given Name',
			key: 'given_name',
			required: true,
			displayOrder: 3,
			type: 'string',
			placeholder: 'Given Name',
		},
		{
			label: 'Family Name',
			key: 'family_name',
			required: true,
			displayOrder: 4,
			type: 'string',
			placeholder: 'Family Name',
		},
		{
			label: 'Account Name',
			key: 'name',
			required: true,
			displayOrder: 5,
			type: 'string',
			placeholder: 'Account Name',
		},
	],
}
